import { render } from "./Solutions.vue?vue&type=template&id=3051701a&scoped=true"
import script from "./Solutions.vue?vue&type=script&lang=js"
export * from "./Solutions.vue?vue&type=script&lang=js"

import "./Solutions.vue?vue&type=style&index=0&id=3051701a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3051701a"]])

export default __exports__